import {
  AfterContentInit,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
  Component,
  ContentChildren,
  OnChanges,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  TemplateRef,
  SimpleChanges,
  Renderer2,
  ChangeDetectorRef,
  effect,
  signal,
  Signal,
  WritableSignal,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { CxTableTemplate } from './directives/cx-table-template.directive';
import { Subject, Subscription, debounceTime, takeUntil, fromEvent, map } from 'rxjs';
import { CxTableService } from './services/cx-table.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { ColumnSelection } from './types/selection';
import { SideBarTypes } from './types/sidebar';
import { momentCustomInstance as moment, CheckPermission } from '@projects/shared/src/app/utils/helper';
import { IPaginate } from '../pagination/paginate.pipe';
import { CxDataGridService } from './cx-datagrid.service';
import { GridMode } from './types/gridmode';
import { CellWidth } from './cx-datagrid-config';
import { cloneDeep } from 'lodash';
import { convertToSeconds } from '../../utils';
import { CxAdvFiltersDataService } from '../cx-adv-filters/cx-adv-filters-data.service';

@Component({
  selector: 'cx-datagrid',
  templateUrl: './cx-datagrid.component.html',
  styleUrl: './cx-datagrid.component.scss',
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(30%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(100%)' }))]),
    ]),
    trigger('slideInOutSidebar', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(100%)' }))]),
    ]),
  ],
})
export class CxDatagridComponent implements OnInit, OnChanges, AfterContentInit, AfterViewInit, OnDestroy {
  GridMode = GridMode;
  showActions = true;
  showSideBar = false;
  rowActions = false;
  showFilters = true;
  selectedView = '';
  beforeReportViewId = '';
  tempView: any;
  // width = 1000;
  width = 100;
  headerTemplate!: TemplateRef<any>;
  noDataTemplate!: TemplateRef<any>;
  actionButtonTemplate!: TemplateRef<any>;
  bodyTemplate!: TemplateRef<any>;
  cardViewTemplate!: TemplateRef<any>;
  bodyDetailTemplate!: TemplateRef<any>;
  subscriptions = new Array<Subscription>();
  sideBarType = SideBarTypes.Filters;
  SideBarTypes = SideBarTypes;
  fields: any[] = [];
  editViewRecord: any;
  @Input() selectedTab = '';
  searchQuery = '';
  random = 0;
  views: any[] = [];
  tempViewsForTabs: any[] = [];

  @ViewChild('search') searchElement!: ElementRef;
  @ContentChildren(CxTableTemplate) templates!: QueryList<CxTableTemplate>;
  @Input() className = 'table';
  @Input() inputPlaceholder = 'Search Name, BTN, Email';
  @Input() showModes = true;
  @Input() showExport = true;
  @Input() showCardView = false;
  @Input() gridMode: GridMode = GridMode.Grid;
  @Input() module = '';
  @Input() fieldmodule = '';
  @Input() title = '';
  @Input() rows: any[] = [];
  @Input() customViews: any[] = [];
  @Input() columns: any[] = [];
  @Input() gridtabs: any[] = [];
  @Input() tTemplate = '';
  @Input() pagingConfig!: IPaginate;
  @Input() moreOptions = {
    label: '',
    directComponentRender: false,
    showFrozenOption: true,
    saveConfig: false,
  };

  @Output() createView = new EventEmitter();
  @Output() updateView = new EventEmitter();
  @Output() changeViews = new EventEmitter();
  @Output() filter = new EventEmitter();
  @Output() onPageChange = new EventEmitter();
  @Output() onPageSizeChange = new EventEmitter();
  @Output() export = new EventEmitter();
  @Output() final = new EventEmitter();
  @Output() search = new EventEmitter();
  @Output() tabchange = new EventEmitter();
  @Output() save = new EventEmitter();

  $input: Subject<any> = new Subject<any>();
  searchableColumns: { query: any; field: any; operatorName: any }[] = [];

  constructor(
    public tableService: CxTableService,
    private cd: ChangeDetectorRef,
    private cxDataGridService: CxDataGridService,
    private renderer: Renderer2,
    private cxAdvFilterData: CxAdvFiltersDataService
  ) {
    this.$input.pipe(debounceTime(600)).subscribe((meta: any) => {
      this.onFilter();
    });

    this.subscriptions.push(
      this.tableService.$random.subscribe((val: any) => {
        this.random = val;
      }),

      this.tableService.$selection.subscribe((x: ColumnSelection) => {
        if (x.type === 'column') {
          if (x.data.selected) {
            this.rows.forEach((x: any) => {
              x.selected = true;
            });
          } else {
            this.rows.forEach((x: any) => {
              x.selected = false;
            });
          }
          this.setRowActions();
        } else {
          const rowIndex = this.rows.findIndex((row) => row._id === x.data?._id);
          if (rowIndex > -1) {
            this.rows[rowIndex].selected = x.data.selected;
          }
          this.setRowActions();
        }
      })
    );
  }

  onSearch(e: MouseEvent) {
    if (!this.searchQuery) {
      return;
    }
    const searchableColumns = this.columns
      .filter((x) => x.searchable)
      .map((x: any) => {
        return { query: this.searchQuery, field: x.searchField, operatorName: x.searchFieldOperator };
      });
    this.searchableColumns = searchableColumns;
    this.onFilter({}, false);
  }

  ngAfterViewInit(): void {
    this.random = this.tableService.random;
    if (this.searchElement?.nativeElement) {
      this.subscriptions.push(
        fromEvent(this.searchElement.nativeElement, 'keyup')
          .pipe(
            map((event) => this.searchElement.nativeElement.value),
            debounceTime(400)
          )
          .subscribe((val) => {
            const searchableColumns = this.columns
              .filter((x) => x.searchable)
              .map((x: any) => {
                return { query: val, field: x.searchField, operatorName: x.searchFieldOperator };
              });
            this.searchableColumns = searchableColumns;
            this.onFilter({}, false);
          })
      );
    }
  }

  setRowActions() {
    let selectedItems = this.rows.filter((x: any) => x.selected).length;
    if (selectedItems > 0) {
      this.rowActions = true;
    } else {
      this.rowActions = false;
    }
    if (selectedItems === this.rows.length) {
      this.tableService.showSelectAllActions = this.rowActions;
      this.tableService.showSelectMoreThenOneActions = this.rowActions;
    } else {
      this.tableService.showRowActions = this.rowActions;
      this.tableService.showSelectAllActions = false;
      this.tableService.showSelectMoreThenOneActions = selectedItems >= 2;
    }
  }

  setViewPinned(event: MouseEvent, item: any) {
    event.preventDefault();
    event.stopPropagation();
    item.pined = !item.pined;
    this.cxDataGridService.pinUnpin(item.pined, item.id).subscribe((x: any) => {
      this.changeViews.emit(this.views);
    });
  }

  getAllPinnedViews() {
    return this.views.filter((x) => x.pined);
  }

  getPinnedViews() {
    if (this.selectedTab === 'reports') {
      return this.views;
    }

    return this.views.filter((x) => x.pined).slice(0, 4);
  }

  ngOnChanges(changes: SimpleChanges) {
   //this.getViews();
    if (changes['columns']) {
      this.tableService.filterColumns = changes['columns'].currentValue.filter((x: any) => x.filter);
      // this.columns = changes['columns'].currentValue;
      const willRenderCols = (this.tableService.columns = changes['columns'].currentValue.filter(
        (x: any) => x.display == true
      ));
      const visibleColsToRender = willRenderCols.filter((x: any) => !x.selection);
      visibleColsToRender.map((x: any) => {
        x.width =
          x.width ||
          (x.width || visibleColsToRender.length < 8
            ? (window.innerWidth - 110) / visibleColsToRender.length
            : CellWidth);
        return x;
      });
    }

    if (changes['gridMode']) {
      this.tableService.gridMode = changes['gridMode'].currentValue;
    }
    // if (changes['views']) {
    // const views = [
    //   { name: 'All', id: '', showPined: false },
    //   ...changes['views'].currentValue
    // ];
    // this.computed_views.set(views)
    // }
    // if (changes['rows']) {
    //   this.rows = changes['rows'].currentValue;
    // }
  }

  getViews(silent = false, onComplete?: () => void) {
    this.cxDataGridService.getViews(this.module, silent).subscribe((views: any) => {
      views.unshift({ name: 'All', native: true, id: '', showPined: false, pined: true, vid: '' });
      this.views = views;
      const found = this.views.find((x) => x.vid === this.selectedView);
      this.selectedView = found?.vid || this.views[0].id;
      this.tempView = found || this.views[0];
  
      if (onComplete) {
        onComplete();
      }
    });
  }

  getFields() {
    let module = this.fieldmodule || this.module;
    this.cxDataGridService.getFields(module).subscribe(async (fieldsGroups: any) => {
      const fields = [];
      for await (let fieldsGroup of fieldsGroups) {
        const remoteFields = fieldsGroup.fields.filter((x: any) => x.remote);
        for await (let remoteField of remoteFields) {
          const index = fieldsGroup.fields.findIndex((x: any) => x.id === remoteField.id);
          const data = await this.cxDataGridService.asPromise(remoteField.remote_url);
          if (index > -1) {
            fieldsGroup.fields[index].field_options = data;
          }
        }
        fields.push(fieldsGroup);
      }

      // add columns filters
      //const columnsFields: any[] = [];
      const columnsFieldsStage1: any[] = [];
      const columnsFieldsStage2: any[] = [];
      this.columns
        .filter((x) => x.selection !== true && x.can_filter !== false && x.display !== false)
        .forEach((column: any) => {
          if (column.type !== 'time') {
            const meta = {
              step: 0,
              component: '',
              field_options: [],
              field_type: column.type || 'string',
              format: column.type,
              fields: [],
              fid: 'column_' + column.key,
              label: column.name,
              name: column.key,
              stage: column.stage || 2,
              remote: false,
              type: column.type || 'string',
              dbField: column.dbField
            };
            const mappedMeta = this.cxAdvFilterData.mapFieldOption(meta);

            if ((column.stage || 2) === 1) {
              columnsFieldsStage1.push(mappedMeta);
            } else {
              columnsFieldsStage2.push(mappedMeta);
            }
            //columnsFields.push(mappedMeta);
          }
        });
        this.fields = fields;

        if (columnsFieldsStage1.length > 0) {
          this.fields.push({
            component: null,
            field_options: null,
            field_type: null,
            stage: 1,
            id: '',
            fields: columnsFieldsStage1,
            label: 'Primary Filters',
            name: 'columns_stage1',
            remote: false,
            remote_method: null,
            remote_url: null,
            type: 'array',
          });
        }
        
        if (columnsFieldsStage2.length > 0) {
          this.fields.push({
            component: null,
            field_options: null,
            field_type: null,
            stage: 2,
            id: '',
            fields: columnsFieldsStage2,
            label: 'Secondary Filters',
            name: 'columns_stage2',
            remote: false,
            remote_method: null,
            remote_url: null,
            type: 'array',
          });
        }

      // const columnFieldGroup = {
      //   component: null,
      //   field_options: null,
      //   field_type: null,
      //   stage: 2,
      //   id: '',
      //   fields: columnsFields,
      //   label: 'Columns',
      //   name: 'columns',
      //   remote: false,
      //   remote_method: null,
      //   remote_url: null,
      //   type: 'array',
      // };
      // this.fields = fields;
      // this.fields.push(columnFieldGroup);
    });
  }

  ngOnInit(): void {
    this.getViews();
    this.getFields();
  }

  onShowSideBar(type = SideBarTypes.Filters) {
    this.sideBarType = type;
    this.showSideBar = !this.showSideBar;
  }

  ngAfterContentInit(): void {
    this.templates.forEach((template: CxTableTemplate) => {
      if (template.name === 'body') {
        this.bodyTemplate = template.template;
      } else if (template.name === 'bodyDetail') {
        this.bodyDetailTemplate = template.template;
      } else if (template.name === 'header') {
        this.headerTemplate = template.template;
      } else if (template.name === 'nodata') {
        this.noDataTemplate = template.template;
      } else if (template.name === 'actionButton') {
        this.actionButtonTemplate = template.template;
      } else if (template.name === 'card') {
        this.cardViewTemplate = template.template;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  getQuickFilters() {
    const quickFilters: Array<{ name: string; value: string; cvalue: string }> = [];
    this.columns
      .filter((x) => x.filter)
      .forEach((filter: any) => {
        quickFilters.push({
          name: filter.name,
          value: JSON.stringify(filter.value),
          cvalue: JSON.stringify(filter.cvalue),
        });
      });

    return quickFilters;
  }

  onCreateView($event: any) {
    // if (this.views.length < 5) {

    // }
    $event.quick_filters = this.getQuickFilters();
    this.cxDataGridService.createView(this.module, $event).subscribe((x: any) => {
      this.createView.emit($event);
      this.getViews();
      // this.tempView = null;
      this.selectedView = $event.vid;
    });
  }

  onTempView($event: any) {
    this.tempView = $event;
  }

  updateQuickFilters($event: any) {
    if (typeof $event.id !== 'string' || !$event.id) {
      return;
    }
    setTimeout(() => {
      $event.quick_filters = this.getQuickFilters();
      this.cxDataGridService.updateQuickFilters($event).subscribe(Boolean);
    }, 100);
  }

  onUpdateView($event: any) {
    $event.quick_filters = this.getQuickFilters();
    this.cxDataGridService.updateView(this.module, $event).subscribe((x: any) => {
      this.updateView.emit($event);
      this.getViews();
      // this.tempView = null;
    });
  }

  public getFiltersLength() {
    let view = this.views.find((x: any) => x.vid === this.selectedView);
    view = view?.native ? { ...view, ...this.tempView } : view;

    let count = 0;

    if (view) {
      view?.filters_group
        ?.filter((x: any) => !x.deleted)
        .forEach((group: any) => {
          var groups = group.filters.filter((x: any) => !x.deleted);
          count += groups.filter((filter: any) => !filter.deleted).length;
        });
    }

    return count;
  }

  onUpdateViewName($event: any) {
    this.getViews(true);
  }

  onCheck($event: any) {
    this.onFilter($event);
  }

  handlePageChange(event: any) {
    this.onPageChange.emit(event);
    this.clearRowSelections();
  }

  onCustomDateFilter($event: any) {
    // console.log($event);
  }

  handlePageSizeChange(event: any) {
    this.onPageSizeChange.emit(event);
    this.clearRowSelections();
  }

  onFilter(view: any = {}, is_refresh = false) {
    const values = this.columns
      .filter((x) => x.filter)
      .map((x) => {
        if (x.type === 'date') {
          const dates = [moment().startOf('day').toISOString(), moment().endOf('day').toISOString()];
          if (!x.value || x.value === 'Today') {
            dates[0] = moment().startOf('day').toISOString();
            dates[1] = moment().endOf('day').toISOString();
            x.value = dates;
          } else if (x.value === 'Yesterday') {
            dates[0] = moment().subtract(1, 'day').startOf('day').toISOString();
            dates[1] = moment().subtract(1, 'day').endOf('day').toISOString();
            x.value = dates;
          } else if (x.value === 'This Week') {
            dates[0] = moment().startOf('week').toISOString();
            dates[1] = moment().endOf('day').toISOString();

            x.value = dates;
          } else if (x.value === 'Last Week') {
            dates[0] = moment().subtract(1, 'week').startOf('week').toISOString();
            dates[1] = moment().subtract(1, 'week').endOf('week').toISOString();

            x.value = dates;
          } else if (x.value === 'This Month') {
            dates[0] = moment().startOf('month').toISOString();
            dates[1] = moment().endOf('day').toISOString();

            x.value = dates;
          } else if (x.value === '3MTD') {
            dates[0] = moment().subtract(3, 'months').startOf('month').toISOString();
            dates[1] = moment().endOf('day').toISOString();

            x.value = dates;
          } else if (x.value === 'All') {
            dates[0] = moment().subtract(10, 'years').startOf('year').toISOString();
            dates[1] = moment().endOf('day').toISOString();

            x.value = dates;
          } else if (x.value === 'Last Month') {
            dates[0] = moment().subtract(1, 'month').startOf('month').toISOString();
            dates[1] = moment().subtract(1, 'month').endOf('month').toISOString();

            x.value = dates;
          } else if (x.value === 'Custom') {
            dates[0] = moment().startOf('day').toISOString();
            dates[1] = moment().endOf('day').toISOString();

            x.value = dates;
          }
        }

        return { key: x.key, value: x.value };
      });

    const hasFilters = Array.isArray(view.filters_group) && view.filters_group.length > 0;

    const currentView =
      (!view.id && view.cid) || view.check || hasFilters ? view : this.views.find((x) => x.vid === this.selectedView);
    if (currentView?.showPined == false) {
      // native view All
      currentView.filters_group = Array.isArray(currentView?.filters_group)
        ? currentView.filters_group.filter((x: any) => !x.deleted)
        : [];
      const tempFilters = Array.isArray(this.tempView?.filters_group)
        ? this.tempView.filters_group.filter((x: any) => !x.deleted)
        : [];
      const uniquieFilters: any[] = [];

      [...currentView.filters_group, ...tempFilters].forEach((q) => {
        if (!uniquieFilters.find((x) => x.gid === q.gid)) {
          uniquieFilters.push(q);
        }
      });

      currentView.filters_group = uniquieFilters;
    } else if (Array.isArray(currentView?.filters_group)) {
      currentView.filters_group = currentView.filters_group.filter((x: any) => !x.deleted);
    }

    const paylod = this.buildPayload(currentView);
    this.updateQuickFilters(currentView);
    this.filter.emit({ filters: values, adv_filters: paylod, searchMeta: this.searchableColumns, is_refresh });
  }

  onQuickFilter(view: any = {}) {
    const hasFilters = Array.isArray(view.filters_group) && view.filters_group.length > 0;
    const currentView =
      (!view.id && view.cid) || view.check || hasFilters ? view : this.views.find((x) => x.vid === this.selectedView);
    const paylod = this.buildPayload(currentView);
    // this.updateView(paylod);
  }

  onViewChange(e: any, fromDropdown = false) {
    document.body.click();
    if (fromDropdown) {
      this.selectedView = e;
    }
    this.tempView = null;
    this.showSideBar = false;

    const currentView = this.views.find((x) => x.vid === this.selectedView);
    if (currentView && Array.isArray(currentView.quick_filters) && currentView.quick_filters.length > 0) {
      this.columns = this.columns.map((col) => {
        if (col.filter) {
          const filter = currentView.quick_filters.find((x: any) => x.name === col.name);
          if (filter) {
            col.cvalue = JSON.parse(filter.cvalue);
            col.value = JSON.parse(filter.value);
          }
        }
        return col;
      });
    } else if (!currentView?.id) {
      this.columns = this.columns.map((col) => {
        if (col.filter) {
          // const filter = currentView.quick_filters.find((x: any) => x.name === col.name);
          col.cvalue = col.dvalue || '';
          col.value = col.dvalue || '';
        }
        return col;
      });
    }

    this.onFilter();
  }

  onRefresh(e: any) {
    e.preventDefault();
    this.onFilter({}, true);
  }

  buildPayload(view: any) {
    const payload: any = [];
    (view?.filters_group || []).forEach((fg: any) => {
      const groupFilters: any[] = [];
      fg.filters.forEach((filter: any) => {
        const selectedFilter = filter.options.find((x: any) => x.value === filter.operatorName);
        const option = this.getFieldOptions(
          filter.operatorName,
          selectedFilter.field_options,
          filter.type,
          filter.field_type
        );
        if (
          (option.value_str && String(option.value_str).trim().length > 0) ||
          (Array.isArray(option.values_list) && option.values_list.length > 0) ||
          (['exists', 'not-exists', 'known', 'unkown'].includes(filter.operatorName) &&
            [true, false].includes(option.value_bool))
        ) {
          groupFilters.push({
            stage: filter.stage,
            operatorName: filter.operatorName,
            name: filter.name,
            dbField: filter.dbField,
            ...option, //.map((x: any) => )
          });
        }
      });
      if (groupFilters.length > 0) {
        payload.push(groupFilters);
      }
    });
    return payload;
  }

  onInputFieldChange($event: any, column: any) {
    column.value = $event;
    this.$input.next({ val: $event, column: column });
  }

  onFiltersClose(e: any) {
    this.onFilter(e);
  }

  getFieldOptions(operator: any, field_options: any[], filterType: string, field_type: string) {
    let value: any = {
      value_str: '',
      value_int: -1,
      value_bool: false,
      values_list: [],
      filter_type: filterType,
      field_type: field_type,
    };
    switch (operator) {
      case 'in':
      case 'contain':
        const vals = field_options.find(Boolean)?.selected_list || [];
        if (vals.length > 0) {
          value.values_list = vals;
          value.values_list = value.values_list.map((x: string) => x.trim());
        }
        break;
      case 'not-in':
      case 'not-contain':
        const vals_nc = field_options.find(Boolean)?.selected_list || [];
        if (vals_nc.length > 0) {
          value.values_list = vals_nc;
          value.values_list = value.values_list.map((x: string) => x.trim());
        }
        break;
      case 'exists':
      case 'known':
        value.value_bool = true;
        break;
      case 'not-exists':
      case 'unkknown':
        value.value_bool = false;
        break;
      case 'is':
      case 'is-equal':
        if (filterType === 'datetime') {
          const selected = field_options.find(Boolean)?.selected;
          if (selected) {
            if (selected === 'yesterday') {
              value.value_str = moment().subtract(1, 'day').toDate();
              value.values_list = [
                moment().subtract(1, 'day').startOf('day').toDate(),
                moment().subtract(1, 'day').endOf('day').toDate(),
              ];
            } else {
              value.value_str =
                moment(field_options.find(Boolean)?.selected, 'YYYY-MM-DD hh:mm:ss a').add(1, 'day').toDate() || '';
              value.values_list = [
                moment(value.value_str).utcOffset(0).startOf('day').toDate(),
                moment(value.value_str).utcOffset(0).millisecond(0).endOf('day').toDate(),
              ];
            }
          }
        }
        if (filterType === 'time') {
          if (field_options.find(Boolean)?.selected) {
            const time =
              moment(field_options.find(Boolean)?.selected, 'YYYY-MM-DD hh:mm:ss a').format('HH:mm:ss') || '';
            value.value_int = convertToSeconds(time);
          }
        } else {
          value.value_str = field_options.find(Boolean)?.selected || '';
        }
        break;
      case 'is-before':
        if (filterType === 'datetime') {
          if (field_options.find(Boolean)?.selected) {
            value.value_str =
              moment(field_options.find(Boolean)?.selected, 'YYYY-MM-DD hh:mm:ss a')
                .add(1, 'day')
                .startOf('day')
                .toDate() || '';
          }
        } else if (filterType === 'time') {
          const time = moment(field_options.find(Boolean)?.selected, 'YYYY-MM-DD hh:mm:ss a').format('HH:mm:ss') || '';
          value.value_int = convertToSeconds(time);
        } else {
          value.value_str = field_options.find(Boolean)?.selected || '';
        }
        break;
      case 'is-after':
        if (filterType === 'datetime') {
          if (field_options.find(Boolean)?.selected) {
            value.value_str =
              moment(field_options.find(Boolean)?.selected, 'YYYY-MM-DD hh:mm:ss a')
                .add(1, 'day')
                .endOf('day')
                .toDate() || '';
          }
        } else if (filterType === 'time') {
          const time = moment(field_options.find(Boolean)?.selected, 'YYYY-MM-DD hh:mm:ss a').format('HH:mm:ss') || '';
          value.value_int = convertToSeconds(time);
        } else {
          value.value_str = field_options.find(Boolean)?.selected || '';
        }
        break;
      case 'is-between':
        if (filterType === 'datetime') {
          if (field_options.map((x) => x.selected).filter((x) => String(x) && String(x).length > 0).length > 0) {
            value.values_list = field_options.map(
              (x) => moment(x?.selected, 'YYYY-MM-DD hh:mm:ss a').add(1, 'day').toDate() || ''
            );
            if (value.values_list.length > 0) {
              value.values_list[0] = moment(value.values_list[0]).startOf('day').toDate();
            }
            if (value.values_list.length > 1) {
              value.values_list[1] = moment(value.values_list[1]).endOf('day').toDate();
            }
          }
        } else {
          value.values_list = field_options.map((x) => x.selected || '');
        }
        break;
      case 'is-more-than':
        if (filterType === 'datetime') {
          if (field_options.at(0).selected) {
            const val = parseInt(field_options.at(0).selected) || 1;
            const opt = field_options.at(1).selected;
            if (opt === 'a-day-ago') {
              value.value_str =
                moment()
                  .subtract(val > -1 ? val : 1, 'days')
                  .toDate() || '';
            }
          }
        } else {
          value.value_str = field_options.find(Boolean)?.selected || '';
        }
        break;
      case 'is-less-than':
        if (filterType === 'datetime') {
          if (field_options.at(0).selected) {
            const val = parseInt(field_options.at(0).selected) || 1;
            const opt = field_options.at(1).selected;
            if (opt === 'a-day-ago') {
              value.value_str =
                moment()
                  .subtract(val > -1 ? val : 1, 'days')
                  .toDate() || '';
            }
          }
        } else {
          value.value_str = field_options?.find(Boolean)?.selected || '';
        }
        break;
      default:
        value.value_str = field_options?.find(Boolean)?.selected || '';
        break;
    }
    return value;
  }

  deleteView($event: MouseEvent, id: string) {
    $event.preventDefault();
    $event.stopPropagation();
  
    const deletedView = this.views.find((x) => x.id === id);
    const wasSelected = !!deletedView && deletedView.vid === this.selectedView;
  
    this.cxDataGridService.deleteView(id).subscribe(() => {
      if (wasSelected) {
        this.selectedView = '';   // native "All" view's vid
        this.tempView = null;
      }
  
      this.getViews(false, () => {
        this.onFilter();
      });
    });
  }

  editView($event: MouseEvent, view: any) {
    $event.preventDefault();
    $event.stopPropagation();

    this.editViewRecord = view;
    this.tableService.showViewNameModal = true;
  }

  onViewNameUpdate() {
    this.getViews();
    this.tableService.showViewNameModal = false;
  }

  onExport($event: { location: string; type: string }) {
    this.export.emit($event);
  }

  onModeChange(mode: GridMode = GridMode.Grid) {
    this.gridMode = mode;
    this.tableService.gridMode = mode;

    this.tableService.setRandom();
  }

  onClearFilters(e: any) {}

  onTabChange($event: MouseEvent, val: string) {
    $event.preventDefault();
    if (val === this.selectedTab) {
      return;
    }
    this.tabchange.emit(val);

    if (val === 'reports') {
      this.showFilters = false;
      this.tempViewsForTabs = cloneDeep(this.views);
      this.views = this.customViews;
      this.beforeReportViewId = this.selectedView;
      this.selectedView = this.views[0].vid;
      const last_filter = this.tempViewsForTabs.find((x) => x.vid === this.beforeReportViewId);
      if (last_filter) {
        this.views[0].filters_group = last_filter.filters_group;
        this.views[0].quick_filters = last_filter.quick_filters;
      }
      this.onViewChange(this.selectedView, false);
    } else {
      this.selectedView = this.beforeReportViewId || '';
      if (this.tempViewsForTabs.length > 0) {
        this.views = this.tempViewsForTabs;
        this.onViewChange(this.selectedView, false);
      }
      this.showFilters = true;
    }
  }

  getOnlyShowableColumns() {
    return this.tableService.columns.filter((x: any) => x.display && x.listmode);
  }

  public getRows() {
    return this.rows;
  }

  public getSelectedRows() {
    return this.rows.filter((r) => r.selected);
  }

  clearRowSelections() {
    this.rows.forEach((x: any) => {
      x.selected = false;
    });
    this.setRowActions();
  }

  public onSave($event: any) {
    this.save.emit($event);
  }
}
